import { orgUserInviteSchema } from '@symon-ai/wisepipe-authorize-domain';
import { tempUserCredentialsSchema } from './tempUserCredentials';
export const tempUserInfoSchema = {
    $id: 'urn:wisepipe-common-auth:TempUserInfo',
    type: 'object',
    properties: {
        tempUserCredentials: { $ref: tempUserCredentialsSchema.$id },
        invite: { $ref: orgUserInviteSchema.$id }
    },
    required: ['tempUserCredentials', 'invite']
};
//# sourceMappingURL=tempUserInfo.js.map